import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'

const FacebookPixelTracker = () => {
  const location = useLocation()

  useEffect(() => {
    ReactPixel.pageView()
  }, [location])

  useEffect(() => {
  console.log('📊 Meta Pixel PageView fired:', location.pathname)
  ReactPixel.pageView()
}, [location])

  return null
}

export default FacebookPixelTracker
